import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import { siteConfig } from "../config/site";
import { siteRoutes } from "../routes";

export function SupportPage() {
  return (
    <>
      <Helmet>
        <title>Support · {siteConfig.name}</title>
        <meta name="description" content={`Get help with ${siteConfig.name}.`} />
      </Helmet>

      <section className="pb-16">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
          support
        </p>
        <h1 className="mt-3 font-display text-4xl tracking-tight sm:text-5xl">How can we help?</h1>
        <p className="mt-4 max-w-xl text-muted-foreground">
          If something went wrong with {siteConfig.name}, send us a note through the{" "}
          <Link
            className="text-foreground underline underline-offset-4"
            to={`${siteRoutes.about}#feedback`}
          >
            feedback form
          </Link>
          . Include your platform and the {siteConfig.name} version so we can understand the report.
        </p>
      </section>

      <section className="border-t border-border/60 py-16">
        <h2 className="font-display text-2xl tracking-tight sm:text-3xl">Privacy requests</h2>
        <p className="mt-3 max-w-xl text-muted-foreground">
          For privacy requests specifically, email{" "}
          <a
            className="font-mono text-foreground underline underline-offset-4"
            href={`mailto:${siteConfig.privacyEmail}`}
          >
            {siteConfig.privacyEmail}
          </a>
          .
        </p>
      </section>
    </>
  );
}
